<template>
    <v-tooltip :right="right" :bottom="bottom">
        <template v-slot:activator="{ on }">
            <v-btn icon @click="click" v-on="on" :disabled="disabled">
                <v-icon :color="color">{{ icon }}</v-icon>
            </v-btn>
        </template>
        <span class="caption" style="box-shadow: none">{{ tooltipText }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: "ButtonIconTooltip",
    props: {
        icon: String,
        color: String,
        tooltipText: String,
        right: {
            type: Boolean,
            default: true
        },
        bottom: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        click() {
            this.$emit('click')
        }
    }
}
</script>

<style scoped>

</style>
